import * as Sentry from '@sentry/sveltekit';

export const logError = (error, tag = 'no_tag') => {
	const errorId = crypto.randomUUID();
	console.log('Error ID:', errorId);
	console.error('Error processing:', error);
	Sentry.setTag('hduk_error_tag', tag);
	Sentry.captureException(error, {
		contexts: { sveltekit: { errorId } }
	});
};
